import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { mainColors } from 'src/assets/colors';
import { easeOpacity } from 'src/domains/layouts/shared/animation/AnimationAndTransition.style';

interface RadioButtonTypes {
    isDisabled: boolean,
    isActive: boolean,
    gap?: string
    showPointer: boolean
}

export const styleDisabledRadio = (isDisabled?: boolean): string | null => {
    if (isDisabled !== undefined && isDisabled === true) {
        return `
            cursor: not-allowed;
            opacity: .3;
            user-select: none;
        `;
    }
    return null;
};

export const setButtonColor = ( isActive: boolean): SerializedStyles => {
    if (isActive) {
        return css`
            &::before {
                border-color: ${mainColors.main.secondary};
            }
            &::after {
                background-color: ${mainColors.main.secondary};
                opacity: 1;
            }
        `;
    }

    return css`
        &::before {
            border-color: ${mainColors.main.secondary};
        }
    `;
};

export const RadioButton = styled('label', { label: 'RadioButton' })<RadioButtonTypes>`
    cursor:  ${({ showPointer }): string => showPointer ? 'pointer' : 'default'};
    position: relative;
    &:not(:last-of-type){
        margin-right: ${({ gap }): string => gap !== undefined ? `${gap}px` : '0'};
    }
    &::before {
        background-color: transparent;
        border: 2px solid ${mainColors.main.secondary};
        border-radius: 50%;
        bottom: 0;
        content: '';
        margin: auto 0;
        position: absolute;
        top: 0;
        transition: box-shadow 0.2s ease;
        border-width: 2px;
        height: 16px;
        width: 16px;
    }
    &::after {
        border-radius: 50%;
        bottom: 0;
        content: '';
        margin: auto 0;
        opacity: 0;
        position: absolute;
        top: 0;
        transition: ${easeOpacity};
        height: 16px;
        width: 16px;
    }
    ${({ isDisabled }): string | null => styleDisabledRadio(isDisabled)};
    ${({ isActive }): SerializedStyles => setButtonColor(isActive)};
`;

export const RadioButtonInput = styled('input', { label: 'RadioButtonInput' })`
    display: none;
`;

interface RadioLabelType {
    size: 'small' | 'large',
}

export const RadioLabel = styled('div', { label: 'RadioLabel' })<RadioLabelType>`
    display: flex;
    font-size: 12px;
    padding-left: ${({ size }): string => (size === 'small' ? '24px' : '32px')};
`;
